<template>
  <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"      
  >
    <v-card
        color="primary"
        dark
    >
      <v-card-text>
        <p class="pt-2">{{ loaderMsg }}</p>
        <v-progress-linear
            indeterminate
            color="white"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'LoadingDialog',
  props: {
    loaderMsg: String
  },
  data() {
    return {
      loadingDialog: false
    }
  },
  methods: {
    closeDialog() {
      this.loadingDialog = false
    },
    openDialog() {
      this.loadingDialog = true
    }
  }
};
</script>
